import ReferralsApi from '@/services/rest/bemob/referral-program';
import UserApi from '@/services/rest/bemob/user';

export class ReferalApi {
  error: boolean = false;
  loading: boolean = false;

  dataReffer: any = {}; //will keep data here
  dataBalance: any = {}; //will keep data here

  api: ReferralsApi = new ReferralsApi();
  apiUser: UserApi = new UserApi();

  getReferred(params:any) {
    this.loading = true;
    return this.api.getReferred(params).then((payload: any) => {
      this.dataReffer = payload;
      this.loading = false;
      return payload;
    });
  };

  getBalance(params:any) {
    this.loading = true;
    return this.api.getBalance(params).then((payload: any) => {
      this.dataBalance = payload;
      this.loading = false;
      return payload;
    });
  }

  put(payload: object) {
    this.loading = true;
    return this.apiUser.putUser(payload).then((payload: any) => {
      this.loading = false;
      return payload;
    });
  }


}

export default new ReferalApi();